import React, { createContext, useState, useEffect, useContext } from 'react';
import { io } from 'socket.io-client';

// 1. FIXED: Corrected the path to match your file structure
import api from '../utils/api'; 
import { AuthContext } from './AuthContext';

export const NotificationContext = createContext();

// 2. FIXED: Added the missing custom hook that Dashboard & NotificationsView are looking for
export const useNotification = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
  const { isAuthenticated, user } = useContext(AuthContext);
  
  // Adding hasUnread derived state to match what your Dashboard expects
  const [unreadCount, setUnreadCount] = useState(0);
  const [hasUnread, setHasUnread] = useState(false);

  // Function to sync with backend
  const fetchUnreadStatus = async () => {
    try {
      // 🚀 MATCHED URL: Use /has-unread to match your route definition
      const res = await api.get('/notifications/has-unread');
      setUnreadCount(res.data.unreadCount || 0);
      setHasUnread(res.data.hasUnread || false);
    } catch (err) {
      console.warn("Silent fetch error (likely initial load):", err.message);
    }
  };

  useEffect(() => {
    if (!isAuthenticated || !user) return;

    // 1. Initial Fetch
    fetchUnreadStatus();

    // 2. Initialize Socket
    const socket = io(process.env.REACT_APP_API_URL || 'http://localhost:5000');

    socket.on('connect', () => {
      console.log('📡 Connected to Socket server');
      socket.emit('register_user', user.userId || user.id); 
    });

    // 3. Live Listener
    socket.on('new_notification', (data) => {
      console.log('🔔 Live Notification Received:', data);
      setUnreadCount(prev => prev + 1);
      setHasUnread(true);
    });

    return () => socket.disconnect();
  }, [isAuthenticated, user]);

  const markAsRead = () => {
    setUnreadCount(0);
    setHasUnread(false);
  };

  return (
    <NotificationContext.Provider value={{ 
      unreadCount, 
      hasUnread, 
      setUnreadCount,
      setHasUnread,
      markAsRead, 
      fetchUnreadStatus 
      }}>
      {children}
    </NotificationContext.Provider>
  );
};

  //useEffect(() => {
    // Only connect if the user is logged in
  //  if (!isAuthenticated || !user) return;

    // Fetch the initial unread count on mount
   // api.get('/notifications/has-unread')
   //   .then(res => setUnreadCount(res.data.count || 0))
   //   .catch(err => console.error("Error fetching notifications:", err));

    // Initialize Socket Connection
   // const socket = io(process.env.REACT_APP_API_URL || 'http://localhost:5000');

   // socket.on('connect', () => {
    //  console.log('📡 Connected to Socket server');
    //  // Register this user's ID with their socket session
     // socket.emit('register_user', user.userId || user.id); 
   // });

    // Listen for real-time incoming notifications
   // socket.on('new_notification', (data) => {
   //   console.log('🔔 Live Notification Received:', data);
  //    setUnreadCount(prev => prev + 1);
  //  });

    // Cleanup on unmount or logout
   // return () => {
   //   socket.disconnect();
   //   console.log('🔌 Disconnected from Socket server');
   // };
  //}, [isAuthenticated, user]);

  // Provide a way to manually reset the count when the user opens the notification tray
 // const markAsRead = () => setUnreadCount(0);

 // return (
 //   <NotificationContext.Provider value={{ unreadCount, hasUnread, setUnreadCount, markAsRead }}>
 //     {children}
//    </NotificationContext.Provider>
 // );
//};